import { all } from "redux-saga/effects";
import { watchBrandSagas } from "./BrandSagas";
import { watchCategorySagas } from "./CategorySagas";
import { watchCommonSagas } from "./CommonSagas";
import { watchLoginSagas } from "./LoginSagas";
import { watchMobilyticsSagas } from "./MobilyticsSagas";
import { watchNotificationSagas } from "./NotificationsSagas";
import { watchPlaceSearchSagas } from './PlaceSearchSagas';
import { watchReportSagas } from "./ReportSagas";
import { watchRetailMatchSagas } from "./RetailMatchSagas";
import { watchUserSagas } from "./UserSagas";

export function* rootSaga() {
    yield all([
        watchReportSagas(),
        watchBrandSagas(),
        watchCategorySagas(),
        watchRetailMatchSagas(),
        watchMobilyticsSagas(),
        watchLoginSagas(),
        watchNotificationSagas(),
        watchPlaceSearchSagas(),
        watchUserSagas(),
        watchCommonSagas(),
    ]);
}
